import React from "react";

const QuotationDetailsPopup = ({
  quotationDetailsData,
  setQuotationDetailsPopup,
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-6 max-w-[30%] w-full shadow-lg relative">
        <h2 className="text-lg font-semibold mb-4">Quotation Details</h2>

        {quotationDetailsData?.map((detail, index) =>
          console.log("detail::", detail)
        )}
        {/* {quotationDetailsData?.map((detail,index)=> */}
        {
          quotationDetailsData?.length > 0 && (
            <div className="space-y-3  max-h-[400px] max-w-[500px]   overflow-y-auto scrollbar-hide">
              <div className="p-4">
                <p>
                  <strong>Quotation Number:</strong>{" "}
                  {quotationDetailsData[0].so_no}
                </p>
                <p>
                  <strong>Date:</strong> {quotationDetailsData[0].so_date}
                </p>
                <p>
                  <strong>Revision Number:</strong>{" "}
                  {quotationDetailsData[0].jv_num}
                </p>
                <p>
                  <strong>Customer Name:</strong>{" "}
                  {quotationDetailsData[0].accdesc}
                </p>
                <p>
                  <strong>Customer Account:</strong>{" "}
                  {quotationDetailsData[0].cust_acc}
                </p>
                <p>
                  <strong>Amount:</strong> {quotationDetailsData[0].so_amount}
                </p>
                <p>
                  <strong>Salesperson:</strong>{" "}
                  {quotationDetailsData[0].sale_man}
                </p>
                <p>
                  <strong>Department No:</strong>{" "}
                  {quotationDetailsData[0].deptno}
                </p>
                <p>
                  <strong>Status:</strong> {quotationDetailsData[0].so_status}
                </p>
              </div>

              {quotationDetailsData?.map((detail, index) => (
                <div className="border rounded-md p-4">
                  <p>items{detail.length}</p>
                  <p>
                    <strong>Item Code:</strong> {detail?.so_icode}
                  </p>
                  <p>
                    <strong>Item Description:</strong> {detail?.idesc}
                  </p>
                </div>
              ))}
            </div>
          )
          // ) : (
          //   <p className="text-gray-500">No data available</p>
          // )
        }

        {/* Close Button */}
        <button
          onClick={() => setQuotationDetailsPopup(false)}
          className="absolute top-3 right-3 bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default QuotationDetailsPopup;
